var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "post-section-4"
  }, [_c("div", {
    staticClass: "post-section-4-content"
  }, [_c("div", {
    staticClass: "post-section-4-media-1"
  }, [_c("img", {
    attrs: {
      src: _vm.urlForImage(_vm.sectionData.image1).width(2000).url(),
      alt: "image"
    }
  })]), _c("div", {
    staticClass: "post-section-4-media-2"
  }, [_c("img", {
    attrs: {
      src: _vm.urlForImage(_vm.sectionData.image2).width(2000).url(),
      alt: "image"
    }
  })])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };